// extracted by mini-css-extract-plugin
module.exports = {"videoError":"style_videoError__1kUrt","videoContainer":"style_videoContainer__2R2Aa","videoCountDown":"style_videoCountDown__3_5m7"};